import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/item-v0.1.0'

export default jsNode('item', {
	'v0.1.0': v010,
})
